import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import constant from "../../../../Shared/constants/constants";
import { categoryOptions, images, BaseUrl } from "../../../../Shared";

import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { capitalize, isFloat } from "../../../../utils/index";
import addCommas from "add-commas";
import nitroPaymentAbi from "../../../../Shared/nitroPaymentABI.json";
import erc20Abi from "../../../../Shared/erc20Abi.json";
import BigNumber from "bignumber.js";
import swal from "sweetalert";
import { Form, Input } from "antd";
import Slider from "react-slick";
//Styles
import "../../../../css/BuyNFM.css";
import "../../../../css/Payment.css";

//Images
import clickit from "../../../../images/clickit.gif";
import huobi from "../../../../images/huobi-global.svg";
import pangolin from "../../../../images/Pangolin.svg";

// blockchain - start
import Web3 from "web3";
import Cookies from "universal-cookie";
import { getWalletAddress } from "../../../../store/selectors/WalletSelectors";
import { setWalletAddress } from "../../../../store/actions/WalletActions";
const cookies = new Cookies();
// blockchain - end

function BuyNFM(props) {
	const walletAddress = useSelector((state) => getWalletAddress(state));

	const [allProducts, setAllProducts] = useState([]);
	const history = useHistory();

	const dispatch = useDispatch();
	const [discountObj, setDiscountObj] = useState(null);
	let [selectedToken, setSelectedToken] = useState(0);
	const [TNCAgreed, setTNCAgreed] = useState(false);
	const [promoCode, setPromoCode] = useState("");
	const [balance, setBalance] = useState(0);
	const [form] = Form.useForm();
	let _nCashSelectedToken = constant.NCASH;
	const [ncashCryptoPaymentAmountToPay, setNcashCryptoPaymentAmountToPay] =
		useState(false);
	let [NCashBalance, setNCashBalance] = useState(0);
	let [totalNcash, setTotalNcash] = useState(0);
	const [clickedIndex, setClickedIndex] = useState(-1);
	let [isWalletConnected, setWalletConnected] = useState(false);
	let [connectedWallet, setConnectedWallet] = useState(false);
	let [paymentTokenToshow, setPaymentTokenToShow] = useState("WBTC");
	let [paymentAmountToShow, setPaymentAmountToShow] = useState(0);
	let [isAlreadyApproved, setIsAlreadyApproved] = useState(false);
	const [paymentInProgress, setPaymentInProgress] = useState(false);
	let [isApprovedTxAvailable, setIsApprovedTxAvailable] = useState(false);
	let [approvedTx, setApprovedTx] = useState(null);
	let [amountToPayInUSD, setAmountToPayInUSD] = useState(0);
	let [isPayTxAvailable, setIsPayTxAvailable] = useState(false);
	let [payTx, setPayTx] = useState(null);
	let [amountPaid, setAmountPaid] = useState(0);
	let [payToken, setPayToken] = useState(null);
	let [ncashPayToken, setNcashPayToken] = useState(null);
	let [amountToPayWrapped, setAmoutForWrapped] = useState(0);
	let [cryptoPaymentAmount, setCryptoPaymentAmountToPay] = useState(0);
	// const loginUserMail = localStorage.getItem("loginUserMail");
	let [walletToken, setWalletToken] = useState("");
	let [userId, setUserId] = useState("");
	let [nCashToken, setNCashToken] = useState("");

	const [availableBots, setAvailableBots] = useState([]);

	let [web3, setWeb3] = useState(null);

	const refreshPage = () => {
		window.location.reload();
	};

	const initialCategory =
		props.location.state?.initialCategory ?? categoryOptions[0].value;
	const [category, setCategory] = useState(initialCategory);

	const [tierQuantity, setTierQuantity] = useState({
		"tier-1": 0,
		"tier-2": 0,
		"tier-3": 0,
	});

	const availableBotImages = {
		Iconic: images.iconicMarketplace,
		Premium: images.premiumMarketplace,
		Top: images.topMarketplace,
	};

	//Slider Options
	const sliderBanner = {
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
	};

	// const [fixedTierquantity, setFixedTierQuantity] = useState({
	//   "tier-1": 0,
	//   "tier-2": 0,
	//   "tier-3": 0,
	// });

	const payWithCoinbase = () => {
		if (!TNCAgreed) {
			swal({
				text: "Please agree to terms and conditions",
				icon: "warning",
			});
			return;
		}

		if (!walletAddress) {
			swal({
				text: "Please connect wallet to proceed",
				icon: "warning",
			});
			return;
		}

		// let values = [tierQuantity["tier-2"], tierQuantity["tier-3"]];
		let values = [tierQuantity["tier-1"], tierQuantity["tier-2"]];

		if (!values.reduce((p, v) => p + v)) {
			swal({
				text: "Please select NFM to proceed",
				icon: "warning",
			});
			return;
		}

		const apiObj = {
			payment_source: "coinbase",
			wallet_address: connectedWallet,
			promo_code: promoCode,
			tiers: tierQuantity,
		};

		axios
			.post(`${BaseUrl}/createNewOrderCoinbaseStripe`, apiObj)
			.then((response) => {
				if (response?.data?.status) {
					console.log(response.data.data);
					window.open(response?.data?.data?.host_url, "_self");
				}
			})
			.catch((error) => {});
	};

	const getNCashAmount = () => {
		axios
			.get(
				"https://api.coingecko.com/api/v3/simple/price?ids=nucleus-vision&vs_currencies=usd"
			)
			.then((response) => {
				if (response.status === 200) {
					setCryptoPaymentAmountToPay(
						Math.trunc(
							(balance - balance * 0.15) / response.data["nucleus-vision"].usd
						).toString()
					);
					setNcashCryptoPaymentAmountToPay(
						Math.trunc(
							(balance - balance * 0.15) / response.data["nucleus-vision"].usd
						).toString()
					);
					setNCashBalance(
						Math.trunc(
							(balance - balance * 0.15) / response.data["nucleus-vision"].usd
						)
					);
					setTotalNcash(
						Math.trunc(balance / response.data["nucleus-vision"].usd)
					);
					selectThePaymentToken(constant.NCASH, NCashBalance);
				}
			});
	};

	const fetchProducts = (changed = "") => {
		let url = `${BaseUrl}/product/get?page=0`;

		axios
			.get(url)
			.then((response) => {
				if (response.status === 200) {
					setAllProducts(response.data.data);
				} else if (response.status == 401) {
					swal({
						title: "Error!",
						text: "Authorisation error. Please try again later.",
						icon: "error",
					});
				} else if (response.status == 404) {
					swal({
						title: "Error!",
						text: "Page not found. Please try again later.",
						icon: "error",
					});
				} else if (response.status == 500) {
					swal({
						title: "Error!",
						text: "Something went wrong. Please try again later.",
						icon: "error",
					});
				} else if (response.status == 503) {
					swal({
						title: "Error!",
						text: "Something went wrong. Please try again later.",
						icon: "error",
					});
				} else {
					setAllProducts([]);
					swal({
						title: "Error!",
						text: "Something went wrong. Please try again later.",
						icon: "error",
					});
				}
			})
			.catch((error) => {
				swal({
					title: "Error!",
					text: "Something went wrong. Please try again later.",
					icon: "error",
				});
			});
	};

	const removeDiscount = () => {
		setPromoCode("");
		setDiscountObj(null);
		form.resetFields();
	};

	const applyPromoCode = () => {
		let apiObj = {
			tiers: tierQuantity,
			promo_code: promoCode,
			wallet_address: connectedWallet,
		};

		axios
			.post(`${BaseUrl}/applyPromoCode`, apiObj)
			.then((response) => {
				if (response.status === 200) {
					setDiscountObj(response?.data);
				}
			})
			.catch((error) => {
				if (error.response.status === 406) {
					setDiscountObj({ ...error.response.data, balance: 0 });
				}
			});
	};

	const payWithFiat = () => {
		if (!TNCAgreed) {
			swal({
				text: "Please agree to terms and conditions",
				icon: "warning",
			});
			return;
		}

		if (!walletAddress) {
			swal({
				text: "Please connect wallet to proceed",
				icon: "warning",
			});
			return;
		}

		// let values = [tierQuantity["tier-2"], tierQuantity["tier-3"]];
		let values = [tierQuantity["tier-1"], tierQuantity["tier-2"]];

		if (!values.reduce((p, v) => p + v)) {
			swal({
				text: "Please select NFM to proceed",
				icon: "warning",
			});
			return;
		}

		const apiObj = {
			payment_source: "stripe",
			wallet_address: connectedWallet,
			promo_code: promoCode,
			tiers: tierQuantity,
		};

		// (!promoCode.length || !(discountObj?.balance ?? 0)) &&
		//   delete apiObj.promo_code;
		axios
			.post(`${BaseUrl}/createNewOrderCoinbaseStripe`, apiObj)
			.then((response) => {
				if (response?.data?.status) {
					window.open(response?.data?.data?.host_url, "_self");
				}
			})
			.catch((error) => {});
	};

	const connectToWallet = async () => {
		console.log(
			`[nft][src][components][components][pages][paymentpage][connectToWallet] connectToWallet`
		);

		if (typeof window.ethereum !== "undefined") {
			let accounts = await window.ethereum.request({
				method: "eth_requestAccounts",
			});
			window.web3 = new Web3(window.ethereum);
			setWeb3(window.web3);

			let chainId = await window.web3.eth.getChainId();

			if (chainId !== parseInt(constant.CHAIN_ID)) {
				swal({
					title: "Invalid Network!",
					text: `Switch your network to ${constant.NETWORK_NAME}`,
					icon: "error",
					confirmButtonText: "Ok",
				});
				return;
			}

			cookies.set("wallet", accounts[0], { path: "/" });
			cookies.set("wallet_status", 1, { path: "/" });
			setWalletConnected(true);
			setConnectedWallet(accounts[0]);
			dispatch(setWalletAddress(accounts[0]));
			setWeb3(window.web3);
		} else {
			cookies.set("wallet", null, { path: "/" });
			cookies.set("wallet_status", 0, { path: "/" });
			setWalletConnected(false);
			setConnectedWallet(null);
			setWeb3(null);
			console.log("Unsupported Browser/Plugin not installed");
		}
	};

	const disconnectWallet = () => {
		cookies.set("wallet", null, { path: "/" });
		cookies.set("wallet_status", 0, { path: "/" });
		setWalletConnected(false);
		setConnectedWallet("");
		dispatch(setWalletAddress(""));
		setWeb3(null);
		window.location.reload(false);
	};

	const walletCreateOrder = () => {
		const apiObj = {
			payment_source: "wallet",
			wallet_address: connectedWallet,
			promo_code: promoCode,
			tiers: tierQuantity,
		};

		axios
			.post(`${BaseUrl}/createNewOrderCoinbaseStripe`, apiObj, {})
			.then((response) => {
				if (response?.data?.status) {
					localStorage.setItem("walletToken", response?.data?.data?.token);
					localStorage.setItem("userId", response?.data?.data?.user_id);
					// setWalletToken(response?.data?.data?.token);
					// setUserId(response?.data?.data?.user_id);
				} else {
				}
			})
			.catch((error) => {});
	};

	const payWithWallet = async () => {
		if (!TNCAgreed) {
			swal({
				text: "Please agree to terms and conditions",
				icon: "warning",
			});
			return;
		}

		// let values = [tierQuantity["tier-2"], tierQuantity["tier-3"]];
		let values = [tierQuantity["tier-1"], tierQuantity["tier-2"]];

		if (!values.reduce((p, v) => p + v)) {
			swal({
				text: "Please select NFM to proceed",
				icon: "warning",
			});
			return;
		}

		walletCreateOrder();

		console.log(
			`[nft][src][components][components][modal][payWithWallet] Initiated`
		);
		console.log(
			`[nft][src][components][components][modal][payWithWallet] Selected Token`,
			payToken
		);

		await connectToWallet();

		let web3 = new Web3(window.ethereum);
		let accounts = await web3.eth.getAccounts();
		let ERC20 = await new web3.eth.Contract(erc20Abi, payToken);
		let userBalance = await ERC20.methods.balanceOf(connectedWallet).call();
		let userBalanceBN = new BigNumber(userBalance);
		let balanceToPay = new BigNumber(cryptoPaymentAmount);
		let res = userBalanceBN.comparedTo(balanceToPay);
		setAmountPaid(cryptoPaymentAmount);

		if (res === -1) {
			swal({
				icon: "error",
				title: "Failed",
				text: "Insufficient Funds. Please topup your Balance to proceed for payment",
				showConfirmButton: true,
				showCancelButton: false,
				closeOnClickOutside: true,
			});
			return;
		}

		try {
			let NitroPayment = await new web3.eth.Contract(
				nitroPaymentAbi,
				constant.NITRO_PAYMENT_CONTRACT
			);

			if (selectedToken == 1 || selectedToken == 2 || selectedToken == 3) {
				// pay with ERC20

				console.log(amountToPayWrapped, "amountToPayWrapped");
				await NitroPayment.methods
					.payPending(payToken, amountToPayWrapped.toString(), 1)

					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						console.log(
							`[nft][src][components][components][modal][payWithWallet] transactionHash`,
							hash
						);
						setIsPayTxAvailable(true);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setPayTx(txHash);

						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,

							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitTransactionReceipt(hash, "pay", 0, function (err, receipt) {
							if (err != null) {
								return;
							}
						});
					})
					.on("error", function (error, receipt) {
						console.log(
							`[nft][src][components][components][modal][payWithWallet] transactionHash error 1`,
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						return;
					});
			} else if (
				selectedToken == 4 ||
				selectedToken == 5 ||
				selectedToken == 6
			) {
				// pay with stable coin
				await NitroPayment.methods
					.payWithStableCoins(payToken, cryptoPaymentAmount.toString(), 1)
					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						console.log(
							`[nft][src][components][components][modal][payWithWallet] transactionHash`,
							hash
						);
						setIsPayTxAvailable(true);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setPayTx(txHash);

						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,

							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitTransactionReceipt(hash, "pay", 0, function (err, receipt) {
							if (err != null) {
								return;
							}
						});
					})
					.on("error", function (error, receipt) {
						console.log(
							`[nft][src][components][components][modal][payWithWallet] transactionHash error 1`,
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						return;
					});
			}
		} catch (error) {
			console.log(
				`[nft][src][components][components][modal][payWithWallet] transactionHash error 2`,
				error
			);
			swal({
				icon: "error",
				title: "Failed",
				text: "Something went wrong. Please try again!",
				showConfirmButton: true,
				showCancelButton: false,
				closeOnClickOutside: true,
			});
		}
	};

	const handleSelectToken = (event) => {
		try {
			selectThePaymentToken(event.target.value);
			getWeb3();
		} catch (error) {
			console.log(error);
		}
	};

	const getWeb3 = () => {
		if (window.ethereum) {
			try {
				window.web3 = new Web3(window.ethereum);
				setWeb3(window.web3);
			} catch (error) {
				console.log(
					`[nft][src][components][components][modal][getWeb3] Web3 Connection Error`,
					error
				);
			}
		} else {
			setWeb3(null);
		}
	};

	const waitNcashTransactionReceipt = async (
		transactionHash,
		actionType,
		timeOut,
		callback
	) => {
		console.log(
			"[nft][src][components][components][modal][waitNcashTransactionReceipt] transactionHash",
			transactionHash
		);
		var web3 = new Web3(window.ethereum);
		let self = this;

		let timeOutCounter = 0;
		let err = {
			message: "",
		};

		let isWaitRunning = false;

		let getReceiptTimerId = setInterval(function () {
			if (isWaitRunning == false) {
				isWaitRunning = true;
				web3.eth
					.getTransaction(transactionHash)
					.then(function (tx) {
						if (tx == null) {
							clearInterval(getReceiptTimerId);
							console.log(
								`[nft][src][components][components][modal][waitNcashTransactionReceipt] transactionHash ${transactionHash} is not found`
							);
							err.message = "Transaction hash is not found.";
							isWaitRunning = false;
							if (callback) {
								callback(err, null);
							}
							return;
						}

						if (tx.blockNumber == null) {
							if (timeOut > 0) {
								timeOutCounter++;
								if (timeOutCounter >= timeOut) {
									clearInterval(getReceiptTimerId);
									isWaitRunning = false;
									err.message = "Timeout while waiting transaction to confirm.";
									if (callback) {
										callback(err, null);
									}
									return;
								} else {
									console.log(
										`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
									);
									isWaitRunning = false;
									return;
								}
							} else {
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
								);
								isWaitRunning = false;
								return;
							}
						}

						// Transaction confirm
						web3.eth
							.getTransactionReceipt(transactionHash)
							.then(async function (web3TxReceipt) {
								clearInterval(getReceiptTimerId);
								isWaitRunning = false;
								if (web3TxReceipt == null) {
									console.log(
										`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
									);
									swal({
										icon: "error",
										title: "Failed",
										text: "Transaction Failed. Please try again!",
										showConfirmButton: true,
										showCancelButton: false,
										closeOnClickOutside: true,
									});
									setIsAlreadyApproved(false);
								}
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] Transaction receipt ${transactionHash}: ${web3TxReceipt}`
								);
								if (web3TxReceipt.status != false) {
									if (actionType == "approve") {
										swal({
											icon: "success",
											title: "Approved",
											text: "Transaction Successful",
											showConfirmButton: true,
											showCancelButton: false,
											closeOnClickOutside: true,
										});
										setIsAlreadyApproved(true);
									} else if (actionType == "pay") {
										//⚠️ ⚠️ ⚠️ Payment Update API to be done here! ⚠️ ⚠️ ⚠️//

										let apiObj = {
											tx_hash: transactionHash,
											// user_email: loginUserMail,
											user_wallet: connectedWallet,
											amount_paid: amountToPayInUSD,
											paid_token: ncashPayToken,
											NFTs_count: 1,
											user_id: localStorage.getItem("userId"),
											amount: balance,
											tokens: [localStorage.getItem("nCashToken")],
										};

										axios
											.post(`${BaseUrl}/payWithNcash`, apiObj, {
												headers: {
													// Authorization: `Bearer ${userDetails?.loginUserToken}`,
												},
											})
											.then((response) => {
												if (response) {
													swal({
														icon: "success",
														title: "Success",
														text: "Payment Successful",
														showConfirmButton: true,
														showCancelButton: false,
														allowOutsideClick: true,
													}).then(() => {
														setIsPayTxAvailable(true);
														refreshPage();
													});
												}
											});
										history.push("/thank-you");
									}
								}
							})
							.catch(function (error) {
								clearInterval(getReceiptTimerId);
								isWaitRunning = false;
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
								);
								swal({
									icon: "error",
									title: "Cancelled",
									text: error.message,
									showConfirmButton: true,
									showCancelButton: false,
									closeOnClickOutside: true,
								});
								setIsAlreadyApproved(false);
							});
					})
					.catch(function (error) {
						clearInterval(getReceiptTimerId);
						console.log(
							`[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
						);
						swal({
							icon: "error",
							title: "Cancelled",
							text: error.message,
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						setIsAlreadyApproved(false);
					});
			}
		}, 1000);
	};

	const waitTransactionReceipt = async (
		transactionHash,
		actionType,
		timeOut,
		callback
	) => {
		console.log(
			"[nft][src][components][components][modal][waitTransactionReceipt] transactionHash",
			transactionHash
		);
		var web3 = new Web3(window.ethereum);
		let self = this;

		let timeOutCounter = 0;
		let err = {
			message: "",
		};

		let isWaitRunning = false;

		let getReceiptTimerId = setInterval(function () {
			if (isWaitRunning == false) {
				isWaitRunning = true;
				web3.eth
					.getTransaction(transactionHash)
					.then(function (tx) {
						if (tx == null) {
							clearInterval(getReceiptTimerId);
							console.log(
								`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash ${transactionHash} is not found`
							);
							err.message = "Transaction hash is not found.";
							isWaitRunning = false;
							if (callback) {
								callback(err, null);
							}
							return;
						}

						if (tx.blockNumber == null) {
							if (timeOut > 0) {
								timeOutCounter++;
								if (timeOutCounter >= timeOut) {
									clearInterval(getReceiptTimerId);
									isWaitRunning = false;
									err.message = "Timeout while waiting transaction to confirm.";
									if (callback) {
										callback(err, null);
									}
									return;
								} else {
									console.log(
										`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
									);
									isWaitRunning = false;
									return;
								}
							} else {
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
								);
								isWaitRunning = false;
								return;
							}
						}

						// Transaction confirm
						web3.eth
							.getTransactionReceipt(transactionHash)
							.then(async function (web3TxReceipt) {
								clearInterval(getReceiptTimerId);
								isWaitRunning = false;
								if (web3TxReceipt == null) {
									console.log(
										`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
									);
									swal({
										icon: "error",
										title: "Failed",
										text: "Transaction Failed. Please try again!",
										showConfirmButton: true,
										showCancelButton: false,
										closeOnClickOutside: true,
									});
									setIsAlreadyApproved(false);
								}
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] Transaction receipt ${transactionHash}: ${web3TxReceipt}`
								);
								if (web3TxReceipt.status != false) {
									if (actionType == "approve") {
										swal({
											icon: "success",
											title: "Approved",
											text: "Transaction Successful",
											showConfirmButton: true,
											showCancelButton: false,
											closeOnClickOutside: true,
										});
										setIsAlreadyApproved(true);
									} else if (actionType == "pay") {
										//⚠️ ⚠️ ⚠️ Payment Update API to be done here! ⚠️ ⚠️ ⚠️//

										let apiObj = {
											tx_hash: transactionHash,
											// user_email: loginUserMail,
											user_wallet: connectedWallet,
											amount_paid: amountToPayInUSD,
											paid_token: payToken,
											NFTs_count: 1,
											user_id: localStorage.getItem("userId"),
											amount: discountObj?.status
												? balance - discountObj?.amount ?? 0
												: balance,
											tokens: [localStorage.getItem("walletToken")],
											promo_code: promoCode,
										};

										// (!promoCode.length || !(discountObj?.balance ?? 0)) &&
										//   delete apiObj.promo_code;

										axios
											.post(`${BaseUrl}/payWithWallet`, apiObj, {
												// headers: {
												//   Authorization: `Bearer ${userDetails?.loginUserToken}`,
												// },
											})
											.then((response) => {
												if (response) {
													setWalletToken("");
													setNCashToken("");
													swal({
														icon: "success",
														title: "Success",
														text: "Payment Successful",
														showConfirmButton: true,
														showCancelButton: false,
														allowOutsideClick: true,
													}).then(() => {
														setIsPayTxAvailable(true);
														refreshPage();
													});
												}
											});
										history.push("/thank-you");
									}
								}
							})
							.catch(function (error) {
								clearInterval(getReceiptTimerId);
								isWaitRunning = false;
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
								);
								swal({
									icon: "error",
									title: "Cancelled",
									text: error.message,
									showConfirmButton: true,
									showCancelButton: false,
									closeOnClickOutside: true,
								});
								setIsAlreadyApproved(false);
							});
					})
					.catch(function (error) {
						clearInterval(getReceiptTimerId);
						console.log(
							`[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
						);
						swal({
							icon: "error",
							title: "Cancelled",
							text: error.message,
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						setIsAlreadyApproved(false);
					});
			}
		}, 1000);
	};

	const approveNcashNFTPaymentContract = async () => {
		if (!TNCAgreed) {
			swal({
				text: "Please agree to terms and conditions",
				icon: "warning",
			});
			return;
		}
		if (isWalletConnected == true) {
			let web3 = new Web3(window.ethereum);
			let accounts = await web3.eth.getAccounts();

			console.log(
				"[nft][src][components][components][modal][approveNcashNFTPaymentContract] Initiated"
			);
			console.log(
				"[nft][src][components][components][modal][approveNcashNFTPaymentContract] Selected Token to Pay",
				_nCashSelectedToken
			);

			if (_nCashSelectedToken != null) {
				let contractToApprove = constant.NITRO_PAYMENT_CONTRACT;
				let valueToApprove =
					"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";

				let ERC20 = await new web3.eth.Contract(erc20Abi, _nCashSelectedToken);

				try {
					await ERC20.methods
						.approve(contractToApprove, valueToApprove)
						.send({ from: accounts[0] })
						.on("transactionHash", function (hash) {
							setIsApprovedTxAvailable(true);
							console.log(
								"[nft][src][components][components][modal][approveNFTPaymentContract] Approve Tx Hash",
								hash
							);
							let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
							setApprovedTx(txHash);

							swal({
								icon: "info",
								title: "In progress",
								text: `Transaction Initiated, Please wait!`,
								closeOnClickOutside: false,
								buttons: ["View Transaction"],
								cancel: false,
								confirm: false,
							}).then(function () {
								window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
							});

							waitTransactionReceipt(
								hash,
								"approve",
								0,
								function (err, receipt) {
									if (err != null) {
										return;
									}
								}
							);
						})
						.on("error", function (error, receipt) {
							console.log(
								"[nft][src][components][components][modal][approveNFTPaymentContract] Approve Tx Error",
								error
							);
							swal({
								icon: "error",
								title: "Failed",
								text: "Transaction cancelled. Please try again!",
								showConfirmButton: true,
								showCancelButton: false,
								closeOnClickOutside: true,
							});
							setIsAlreadyApproved(false);
							return;
						});
				} catch (error) {
					console.log(
						"[nft][src][components][components][modal][approveNFTPaymentContract] Catch Error",
						error
					);
					swal({
						icon: "error",
						title: "Failed",
						text: "Something went wrong. Please try again!",
						showConfirmButton: true,
						showCancelButton: false,
						closeOnClickOutside: true,
					});
					setIsAlreadyApproved(false);
				}
			} else {
				swal({
					text: "Please select your currency to proceed",
					icon: "error",
				});
			}
		} else {
			await getWeb3();
			await connectToWallet();
			swal({
				title: "Failed",
				text: `Please connect your wallet.`,
				icon: "error",
				confirmButtonText: "Ok",
			});
		}
	};

	const selectThePaymentToken = async (__selectedToken) => {
		setSelectedToken(__selectedToken);
		try {
			if (isWalletConnected == true) {
				if (typeof window.ethereum !== "undefined") {
					window.web3 = new Web3(window.ethereum);
					setWeb3(window.web3);
					let NitroPayment = await new window.web3.eth.Contract(
						nitroPaymentAbi,
						constant.NITRO_PAYMENT_CONTRACT
					);

					let _paymentToPay = 0;
					let _paymentToShow = 0;
					let _token = null;
					let __amount = discountObj?.status
						? balance - discountObj?.amount ?? 0
						: balance;
					let _paymentToPayUSD = Math.round(parseFloat(__amount));
					setAmoutForWrapped(_paymentToPayUSD);
					if (__selectedToken == "1") {
						_paymentToPay = await NitroPayment.methods
							.getPriceToPayBTCUSD(_paymentToPayUSD)
							.call();
						_paymentToShow = _paymentToPay / 100000000;
						_token = "WBTC.e";
					} else if (__selectedToken == "2") {
						_paymentToPay = await NitroPayment.methods
							.getPriceToPayETHUSD(_paymentToPayUSD)
							.call();
						_paymentToShow = await window.web3.utils.fromWei(
							_paymentToPay,
							"ether"
						);
						_token = "WETH.e";
					} else if (__selectedToken == "3") {
						console.log("avax option selected");
						_paymentToPay = await NitroPayment.methods
							.getPriceToPayAVAXUSD(_paymentToPayUSD)
							.call();
						console.log(_paymentToPay, "_paymentToPay");
						_paymentToShow = await window.web3.utils.fromWei(
							_paymentToPay,
							"ether"
						);
						_token = "WAVAX";
					} else if (__selectedToken == "4") {
						_paymentToPay = await window.web3.utils.toWei(
							_paymentToPayUSD.toString(),
							"ether"
						);
						_paymentToShow = discountObj?.status
							? balance - discountObj?.amount ?? 0
							: balance;
						_token = "DAI.e";
					} else if (__selectedToken == "5") {
						let _temp = BigNumber(_paymentToPayUSD);
						_paymentToPay = _temp.multipliedBy("1000000").toString();
						_paymentToShow = discountObj?.status
							? balance - discountObj?.amount ?? 0
							: balance;
						_token = "USDC.e";
					} else if (__selectedToken == "6") {
						let _temp = BigNumber(_paymentToPayUSD);
						_paymentToPay = _temp.multipliedBy("1000000").toString();
						_paymentToShow = discountObj?.status
							? balance - discountObj?.amount ?? 0
							: balance;
						_token = "USDT.e";
					} else {
						return;
					}
					setAmountToPayInUSD(
						discountObj?.status ? balance - discountObj?.amount ?? 0 : balance
					);
					setCryptoPaymentAmountToPay(_paymentToPay.toString());
					setPaymentTokenToShow(_token);
					setPaymentAmountToShow(_paymentToShow);
					// console.log(_token);
					isNFTPaymentContractApproved(_token, _paymentToPay);
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const isNFTPaymentContractApproved = async (
		selectedToken,
		amountToApprove
	) => {
		console.log(
			`[nft][src][components][components][modal][isNFTPaymentContractApproved] selectedToken`,
			selectedToken
		);
		await getWeb3();

		let _selectedToken = null;

		if (selectedToken == "WBTC.e") {
			_selectedToken = constant.WBTC;
		} else if (selectedToken == "WETH.e") {
			_selectedToken = constant.WETH;
		} else if (selectedToken == "WAVAX") {
			_selectedToken = constant.WAVAX;
		} else if (selectedToken == "DAI.e") {
			_selectedToken = constant.DAI;
		} else if (selectedToken == "USDC.e") {
			_selectedToken = constant.USDC;
		} else if (selectedToken == "USDT.e") {
			_selectedToken = constant.USDT;
		} else {
			_selectedToken = "0x0000000000000000000000000000000000000000";
		}

		setPayToken(_selectedToken);

		if (
			_selectedToken != "null" ||
			_selectedToken != "0x0000000000000000000000000000000000000000"
		) {
			let erc20 = await new window.web3.eth.Contract(erc20Abi, _selectedToken);

			// balance to Pay
			let balanceToPay = new BigNumber(amountToApprove);

			connectToWallet();

			try {
				if (isWalletConnected == true) {
					if (connectToWallet != null) {
						let isApproved = await erc20.methods
							.allowance(connectedWallet, constant.NITRO_PAYMENT_CONTRACT)
							.call();

						let decimal = await erc20.methods.decimals().call();

						let baseBN = new BigNumber(10);
						let decimalBN = new BigNumber(decimal);

						let exponentiate = baseBN.exponentiatedBy(decimalBN);

						let isApprovedBN = new BigNumber(isApproved);
						let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
							exponentiate
						);

						let res = isApprovedBN.comparedTo(balanceToPayBN);
						console.log(
							`[nft][src][components][components][modal][isNFTPaymentContractApproved] res`,
							res
						);

						if (res === 0 || res == 1) {
							setIsAlreadyApproved(true);
						} else if (res == -1) {
							setIsAlreadyApproved(false);
						}
						console.log(
							`[nft][src][components][components][modal][isNFTPaymentContractApproved] Is Approved`,
							isAlreadyApproved
						);
					}
				} else {
					setIsAlreadyApproved(false);
				}
			} catch (error) {
				console.log(error);
			}
		} else {
			setIsAlreadyApproved(false);
		}
	};

	const isNcashNFTPaymentContractApproved = async (
		selectedToken,
		amountToApprove
	) => {
		console.log(
			`[nft][src][components][components][modal][isNcashNFTPaymentContractApproved] selectedToken`,
			selectedToken
		);
		await getWeb3();

		let _selectedToken = null;
		_selectedToken = constant.NCASH;
		setNcashPayToken(_selectedToken);

		if (
			_selectedToken != "null" ||
			_selectedToken != "0x0000000000000000000000000000000000000000"
		) {
			let erc20 = await new window.web3.eth.Contract(erc20Abi, _selectedToken);

			// balance to Pay
			let balanceToPay = new BigNumber(amountToApprove);

			connectToWallet();

			try {
				if (isWalletConnected == true) {
					if (connectToWallet != null) {
						let isApproved = await erc20.methods
							.allowance(connectedWallet, constant.NITRO_PAYMENT_CONTRACT)
							.call();

						let decimal = await erc20.methods.decimals().call();

						let baseBN = new BigNumber(10);
						let decimalBN = new BigNumber(decimal);

						let exponentiate = baseBN.exponentiatedBy(decimalBN);

						let isApprovedBN = new BigNumber(isApproved);
						let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
							exponentiate
						);

						let res = isApprovedBN.comparedTo(balanceToPayBN);
						console.log(
							`[nft][src][components][components][modal][isNFTPaymentContractApproved] res`,
							res
						);

						if (res === 0 || res == 1) {
							setIsAlreadyApproved(true);
						} else if (res == -1) {
							setIsAlreadyApproved(false);
						}
						console.log(
							`[nft][src][components][components][modal][isNFTPaymentContractApproved] Is Approved`,
							isAlreadyApproved
						);
					}
				} else {
					setIsAlreadyApproved(false);
				}
			} catch (error) {
				console.log(error);
			}
		} else {
			setIsAlreadyApproved(false);
		}
	};

	const approveNFTPaymentContract = async () => {
		if (!TNCAgreed) {
			swal({
				text: "Please agree to terms and conditions",
				icon: "warning",
			});
			return;
		}
		if (isWalletConnected == true) {
			let web3 = new Web3(window.ethereum);
			let accounts = await web3.eth.getAccounts();

			console.log(
				"[nft][src][components][components][modal][approveNFTPaymentContract] Initiated"
			);
			console.log(
				"[nft][src][components][components][modal][approveNFTPaymentContract] Selected Token to Pay",
				payToken
			);

			if (payToken != null) {
				let contractToApprove = constant.NITRO_PAYMENT_CONTRACT;
				let valueToApprove =
					"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";

				let ERC20 = await new web3.eth.Contract(erc20Abi, payToken);

				try {
					await ERC20.methods
						.approve(contractToApprove, valueToApprove)
						.send({ from: accounts[0] })
						.on("transactionHash", function (hash) {
							setIsApprovedTxAvailable(true);
							console.log(
								"[nft][src][components][components][modal][approveNFTPaymentContract] Approve Tx Hash",
								hash
							);
							let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
							setApprovedTx(txHash);

							swal({
								icon: "info",
								title: "In progress",
								text: `Transaction Initiated, Please wait!`,
								closeOnClickOutside: false,
								buttons: ["View Transaction"],
								cancel: false,
								confirm: false,
							}).then(function () {
								window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
							});

							waitTransactionReceipt(
								hash,
								"approve",
								0,
								function (err, receipt) {
									if (err != null) {
										return;
									}
								}
							);
						})
						.on("error", function (error, receipt) {
							console.log(
								"[nft][src][components][components][modal][approveNFTPaymentContract] Approve Tx Error",
								error
							);
							swal({
								icon: "error",
								title: "Failed",
								text: "Transaction cancelled. Please try again!",
								showConfirmButton: true,
								showCancelButton: false,
								closeOnClickOutside: true,
							});
							setIsAlreadyApproved(false);
							return;
						});
				} catch (error) {
					console.log(
						"[nft][src][components][components][modal][approveNFTPaymentContract] Catch Error",
						error
					);
					swal({
						icon: "error",
						title: "Failed",
						text: "Something went wrong. Please try again!",
						showConfirmButton: true,
						showCancelButton: false,
						closeOnClickOutside: true,
					});
					setIsAlreadyApproved(false);
				}
			} else {
				swal({
					text: "Please select your currency to proceed",
					icon: "error",
				});
			}
		} else {
			await getWeb3();
			await connectToWallet();
			swal({
				title: "Failed",
				text: `Please connect your wallet.`,
				icon: "error",
				confirmButtonText: "Ok",
			});
		}
	};

	const createNcashOrder = () => {
		const apiObj = {
			payment_source: "PaidWithNCash",
			wallet_address: connectedWallet,
			promo_code: promoCode,
			tiers: tierQuantity,
		};

		axios
			.post(`${BaseUrl}/createNewOrderCoinbaseStripe`, apiObj, {})
			.then((response) => {
				if (response?.data?.status) {
					localStorage.setItem("nCashToken", response?.data?.data?.token);
					localStorage.setItem("userId", response?.data?.data?.user_id);
				}
			})
			.catch((error) => {});
	};
	const payWithNcashWallet = async () => {
		if (!TNCAgreed) {
			swal({
				text: "Please agree to terms and conditions",
				icon: "warning",
			});
			return;
		}

		// let values = [tierQuantity["tier-2"], tierQuantity["tier-3"]];
		let values = [tierQuantity["tier-1"], tierQuantity["tier-2"]];

		if (!values.reduce((p, v) => p + v)) {
			swal({
				text: "Please select NFM to proceed",
				icon: "warning",
			});
			return;
		}

		createNcashOrder();

		console.log(
			`[nft][src][components][components][modal][payWithNcashWallet] Initiated`
		);
		console.log(
			`[nft][src][components][components][modal][payWithNcashWallet] Selected Token`
			// nca
		);

		await connectToWallet();

		let web3 = new Web3(window.ethereum);
		let accounts = await web3.eth.getAccounts();
		let ERC20 = await new web3.eth.Contract(erc20Abi, _nCashSelectedToken);
		let userBalance = await ERC20.methods.balanceOf(connectedWallet).call();
		let userBalanceBN = new BigNumber(userBalance);
		let _amountToPay = await web3.utils.toWei(NCashBalance.toString(), "ether");
		let _amountToPayBN = new BigNumber(_amountToPay);
		console.log(_amountToPayBN);

		// let balanceToPay = new BigNumber(ncashCryptoPaymentAmountToPay);
		let res = userBalanceBN.comparedTo(_amountToPayBN);
		setAmountPaid(_amountToPayBN);

		if (res === -1) {
			swal({
				icon: "error",
				title: "Failed",
				text: "Insufficient Funds. Please topup your Balance to proceed for payment",
				showConfirmButton: true,
				showCancelButton: false,
				closeOnClickOutside: true,
			});
			return;
		}

		try {
			let NitroPayment = await new web3.eth.Contract(
				nitroPaymentAbi,
				constant.NITRO_PAYMENT_CONTRACT
			);

			if (true) {
				let _amountToPay = await web3.utils.toWei(
					NCashBalance.toString(),
					"ether"
				);
				let _amountToPayBN = _amountToPay.toString();
				console.log(_amountToPayBN);
				await NitroPayment.methods
					.payWithStableCoins(constant.NCASH, _amountToPayBN, 1)
					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						console.log(
							`[nft][src][components][components][modal][payWithWallet] transactionHash`,
							hash
						);
						setIsPayTxAvailable(true);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setPayTx(txHash);

						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,
							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitNcashTransactionReceipt(
							hash,
							"pay",
							0,
							function (err, receipt) {
								if (err != null) {
									return;
								}
							}
						);
					})
					.on("error", function (error, receipt) {
						console.log(
							`[nft][src][components][components][modal][payWithWallet] transactionHash error 1`,
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						return;
					});
			}
		} catch (error) {
			console.log(
				`[nft][src][components][components][modal][payWithWallet] transactionHash error 2`,
				error
			);
			swal({
				icon: "error",
				title: "Failed",
				text: "Something went wrong. Please try again!",
				showConfirmButton: true,
				showCancelButton: false,
				closeOnClickOutside: true,
			});
		}
	};

	const fetchAvailableBotsCount = async function () {
		try {
			const response = await axios.get(`${BaseUrl}/getNfmTraitsCount`);
			setAvailableBots(response?.data?.data ?? []);
		} catch (error) {
			console.log(error.message);
		}
	};

	// USE EFFECTS
	useEffect(() => {
		fetchProducts();
		fetchAvailableBotsCount();
	}, []);
	useEffect(() => {
		getNCashAmount();
	}, [balance, JSON.stringify(discountObj)]);

	useEffect(() => {
		if (promoCode) {
			applyPromoCode();
		}

		setBalance(
			allProducts.reduce(
				(pval, cval) => pval + cval?.price * tierQuantity[cval?.group_name],
				0
			)
		);
	}, [tierQuantity]);

	useEffect(() => {
		if (walletAddress.length) {
			setConnectedWallet(walletAddress);
			setWalletConnected(true);
		} else {
			setConnectedWallet("");
			setWalletConnected(false);
		}
	}, [walletAddress]);

	return (
		<>
			<div className="dark-scheme buy-nfm-page">
				<div className="tr mt-90pxx">
					{/* <img src={images.topBanner} width="100%" /> */}
					<div className="marketplace-banner mt-90pxx">
						<Slider {...sliderBanner}>
							<a
								href="https://nft.nitro.network/"
								target="_blank"
								rel="noreferrer"
							>
								<img src={images.mintBanner} alt="Banner Markertplace 1" />
							</a>
							<img
								src={images.banner2Marketplace}
								alt="Banner Markertplace 2"
							/>
							<img src={images.bannerMarketplace} alt="Banner Markertplace" />
						</Slider>
					</div>
					<div className="text-btn">
						<div>
							{/* <h1>Nitro Marketplace</h1> */}
							<p
								style={{
									maxWidth: "70em",
									margin: "1rem auto",
									padding: "1rem",
								}}
								className="text-center"
							>
								With DeFi and NFTs catapulted into the mainstream, Nitro
								Network’s Non-Fungible Miners, or NFMs, have arrived at the
								perfect moment in blockchain history. NFMs were created from the
								synthesis of decentralized finance and non-fungible tokens, the
								two most influential spheres in the blockchain space. The NFM
								ecosystem, with its IoT solutions, harnesses the limitless
								energy of these exciting fields. And with its ethos of fair
								play, everyone who participates wins.
							</p>
						</div>
					</div>
				</div>

				{/* AVAILABLE  NFM BOTS */}
				<div className="available-nfm-bot-section">
					<div className="max-width">
						<h2 className="uppercase">AVAILABLE nfm bots</h2>
						<div className="available-nfm-bots">
							{/* First Bot */}
							{availableBots.map((bot) => (
								<div className="available-bot">
									<div className="available-bot__image border-sky">
										<img
											src={availableBotImages[bot.type]}
											alt={`${bot.type} NFM`}
										/>
									</div>
									<h2>{bot.total_count}</h2>
									<p className="available-bot__category white-btn-bg">
										{(bot?.type ?? "").toUpperCase()}
									</p>

									{/* lEFT NFMS  */}
									{/* <div className="left-nfm-stats">
										<div className="dfac dfjb">
											<p className="fw-400">Rare</p>
											<p className="fw-400">{bot.rare}</p>
										</div>
										<div className="dfac dfjb">
											<p className="fw-400">Standard</p>
											<p className="fw-400">{bot.standard}</p>
										</div>
										<div className="dfac dfjb">
											<p className="fw-400">Ultra Rare</p>
											<p className="fw-400">{bot.ultra_rare}</p>
										</div>
									</div> */}
								</div>
							))}
						</div>
					</div>
				</div>

				<section className="backgroundColordark ">
					<div className="row wow fade-in justify-content-center collection-boxes center-align-marketplacelist-buy">
						{allProducts.length
							? allProducts.map((nft, index) => (
									<div
										key={index}
										id="marketplace"
										className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
									>
										<div className="max-nft-item-220 nft__item">
											<div className="nft__item_wrap max-wh-200">
												<a>
													<img
														src={nft?.product_image}
														className="lazy nft__item_preview"
														alt={nft?.mystery}
													/>
												</a>
											</div>

											<div
												className="nft__item_info row-justify-custom"
												style={{ minHeight: 34 }}
											>
												{/* <div>
                      <p className="purple-text">{nft?.mystery}</p>
                    </div> */}
												{false ? (
												// {nft?.group_name !== "tier-3" ? (
													// <div
													// 	className="text-center d-flex justify-content-center align-items-center"
													// 	style={{ margin: "auto" }}
													// >
													// 	<span className="qty">Qty:&nbsp;&nbsp;&nbsp;</span>

													// 	<div className="counter">
													// 		<p
													// 			className="minus"
													// 			id="white-color"
													// 			style={{ color: "#ffffff" }}
													// 			onClick={
													// 				tierQuantity[nft?.group_name]
													{/*					? () => {*/}
													// 							setTierQuantity((prevState) => ({
													// 								...prevState,
													// 								[nft?.group_name]:
													// 									prevState[nft?.group_name] - 1,
													// 							}));
													// 					  }
													// 					: () => {}
													// 			}
													// 		>
													// 			<i className="fa fa-minus"></i>
													// 		</p>
													// 		<input
													// 			type="number"
													// 			name="update"
													// 			id="number-update"
													// 			value={tierQuantity[nft?.group_name]}
													// 			onChange={() => {}}
													// 		/>
													// 		<p
													// 			className="plus"
													// 			style={{ color: "#ffffff" }}
													// 			id="white-color"
													// 			onClick={() => {
													// 				setTierQuantity((prevState) => ({
													// 					...prevState,
													// 					[nft?.group_name]:
													// 						prevState[nft?.group_name] + 1,
													// 				}));
													// 			}}
													// 		>
													// 			<i className="fa fa-plus"></i>
													// 		</p>
													// 	</div>
													// </div>
												) : null}
											</div>
										</div>
										<div style={{ marginLeft: "24px" }}>
											<h3>
												{nft?.category_name?.toUpperCase()}(
												{capitalize(nft?.group_name).split("-").join(" ")})
											</h3>
											<p style={{ fontSize: "16px" }}>{nft?.product_desc}</p>

											{/* TEMP PRICE INCREASE STATIC PRICE * 2  */}
											<h3 className="price_div">Price: ${nft?.price * 2}</h3>
										</div>
									</div>
							  ))
							: null}

						{/* <div className="text-center" id="marketplace-summary">
            <h2>
              Sub Total: $
              {allProducts.reduce(
                (pval, cval) =>
                  pval + cval?.price * tierQuantity[cval?.group_name],
                0
              )}
            </h2>
            <button
              onClick={
                allProducts.reduce(
                  (pval, cval) =>
                    pval + cval?.price * tierQuantity[cval?.group_name],
                  0
                )
                  ? placeOrder
                  : () => {}
              }
              style={
                allProducts.reduce(
                  (pval, cval) =>
                    pval + cval?.price * tierQuantity[cval?.group_name],
                  0
                )
                  ? null
                  : {
                      filter: "brightness(0.65)",
                    }
              }
              className="gradient-box"
            >
              Buy Now
            </button>
          </div> */}
						{/* <div className="text-center">
            Please check your order in account section to{" "}
            <a href="/myaccount/pendingpayments">pay</a>
          </div> */}
					</div>
					{/* <hr className="horizontal_line"></hr> */}
				</section>
				{/* <Footer /> */}
				<div className="pending-pay-page container">
					<h2>Select Payment Method</h2>
					<div className="pay-details-boxes">
						<div className="pay-box">
							<h3 className="mb-2">Apply Coupon</h3>

							<div className="promo-bill-section">
								<div className="promo-section">
									<Form
										onFinish={discountObj ? removeDiscount : applyPromoCode}
										autoComplete="off"
										form={form}
										layout="inline"
									>
										<div className="apply-promo mb-2">
											<Form.Item
												name="promoCode"
												initialValue={form.getFieldValue("promoCode")}
												normalize={(e) => e.trim().toUpperCase()}
												rules={
													discountObj
														? []
														: [
																{
																	required: true,
																	message: "Please enter promo code to apply",
																},
														  ]
												}
											>
												<Input
													type="text"
													placeholder="Enter Promo Code"
													className="purple bordered-button"
													onChange={(e) => {
														const value = e.target.value.trim().toUpperCase();
														setPromoCode(value);
														form.setFieldsValue({ promoCode: value });
													}}
													style={{
														backgroundColor: "#23324e",
													}}
													disabled={discountObj}
												/>
											</Form.Item>

											<button
												type="submit"
												id="pay-now-btn"
												onClick={() => console.log("click triigredfad")}
												style={
													!promoCode.length
														? {
																filter: "brightness(60%)",
																cursor: "not-allowed",
														  }
														: { maxHeight: "36px" }
												}
												disabled={!promoCode.length}
												className="bor  ered-button "
											>
												{discountObj ? "Remove" : "Apply"}
											</button>
										</div>
									</Form>

									<p
										className="line-height1 text-center"
										style={{ fontWeight: "bold" }}
									>
										<small style={{ fontSize: "17px" }}>
											{discountObj?.message ?? ""}
										</small>
										<br />
									</p>
									<p style={{ textAlign: "center" }}> </p>
								</div>
								{/* BILL DETAILS */}
								<div className="bill-detail-section">
									<h4 className="mb-2">Bill Details</h4>
									<div className="dfjb">
										<p className="mb-0 light-weight">Total Amount</p>
										<p className="mb-0">
											${!isFloat(balance) ? addCommas(balance || 0) : balance}
										</p>
									</div>
									<div className="dfjb">
										<p className="light-weight">Discount</p>
										<p>
											-$
											{!isFloat(discountObj?.amount ?? 0)
												? addCommas(discountObj?.amount ?? 0)
												: discountObj?.amount ?? 0}
										</p>
									</div>
									<div className="dfjb borded-tb py-2">
										<p className="mb-0 light-weight">Payable Amount</p>
										<p className="mb-0">
											$
											{!isFloat(balance - (discountObj?.amount ?? 0))
												? addCommas(balance - (discountObj?.amount ?? 0))
												: balance - (discountObj?.amount ?? 0)}
										</p>
									</div>
								</div>
							</div>

							<div className="d-flex align-items-center justify-content-center margin-terms">
								<input
									type="checkbox"
									checked={TNCAgreed}
									onChange={() => setTNCAgreed((prevState) => !prevState)}
								/>
								<p className="mb-0 ml-2">
									I agree to{" "}
									<Link
										to="/terms-and-conditions"
										target="_blank"
										rel="noopener noreferrer"
										className="link-color"
									>
										Terms & Conditions
									</Link>
									{/* <a
                    href="https://nitro.network/terms-and-conditions"
                    target="_blank"
                    className="link-color"
                  >
                    Terms & Conditions
                  </a> */}
								</p>
							</div>
							<h3 className="mb-2 d-none">Payment methods</h3>

							{/* PAY WITH CRYPTO */}
							{/* remove d-none class when payment options enabled */}
							<div className="all-three-payment d-none">
								{/*<div className="one-section-payment d-flex align-items-center justify-content-between">*/}
								{/*  <div className="text-left flex-1">*/}
								{/*    <h6 className="mb-1">Pay with Crypto</h6>*/}
								{/*    <p className="max-width-paragraph">*/}
								{/*      <small className="light-weight">*/}
								{/*        (BTC, BCH, ETH, DAI, DOGE, LTC)*/}
								{/*      </small>*/}
								{/*      <br></br>*/}
								{/*      <small className="light-weight">*/}
								{/*        If paying using USDT, USDC,*/}
								{/*      </small>*/}
								{/*      <br />*/}
								{/*      <small className="light-weight">*/}
								{/*        please send through ETH network only.*/}
								{/*      </small>*/}
								{/*      <br />*/}

								{/*      <small className="light-weight">*/}
								{/*        Powered by <b>coinbase</b>*/}
								{/*      </small>*/}
								{/*    </p>*/}
								{/*  </div>*/}
								{/*  <div className="">*/}
								{/*    <button*/}
								{/*      className="pay-now-small less-padding-button"*/}
								{/*      id="pay-now-btn"*/}
								{/*      // style={paymentInProgress ? { filter: "brightness(0.65)" } : null}*/}
								{/*      onClick={payWithCoinbase}*/}
								{/*    >*/}
								{/*      Pay Now*/}
								{/*    </button>*/}
								{/*  </div>*/}
								{/*</div>*/}

								{/* PAY WITH FIAT */}
								{/*<div className="one-section-payment d-flex align-items-center justify-content-between">*/}
								{/*  <div className="text-left">*/}
								{/*    <h6 className="mb-1">Pay with Fiat</h6>*/}
								{/*    <p>*/}
								{/*      <small className="light-weight">*/}
								{/*        (Pay with Credit/Debit cards)*/}
								{/*      </small>*/}
								{/*    </p>*/}
								{/*  </div>*/}
								{/*  <div className="">*/}
								{/*    <button*/}
								{/*      className="pay-now-small less-padding-button"*/}
								{/*      id="pay-now-btn"*/}
								{/*      // style={paymentInProgress ? { filter: "brightness(0.65)" } : null}*/}
								{/*      onClick={payWithFiat}*/}
								{/*    >*/}
								{/*      Pay Now*/}
								{/*    </button>*/}
								{/*  </div>*/}
								{/*</div>*/}
								{/* PAY WITH METAMASK WALLET NEW */}
								{/* <div className="one-section-pay">
									<div className="pay-metamask">
										<div className=" left-side">
											<h6 className="mb-2">Pay with Crypto</h6>
											<div className="use-network text-left">
												<p className="mb-1">
													<small className="light-weight">
														(Use Avalanche network)
														<br />
													</small>
													<small
														style={{
															maxWidth: "50%",
															wordBreak: "break-word",

														}}
													>
														{walletAddress != "undefined" &&
														walletAddress?.length ? (
															<>
																{"Connected : " +
																	walletAddress.slice(0, 5) +
																	".".repeat(3) +
																	walletAddress.slice(-4)}
																&nbsp;&nbsp;
																<span
																	title="Disconnect Wallet"
																	style={{
																		display: "inline-block",
																		color: "white",
																		cursor: "pointer",
																		backgroundColor: "#161d30",
																		width: "25px",
																		height: "25px",
																		fontSize: "15px",
																		borderRadius: "50%",
																		textAlign: "center",
																	}}
																	onClick={disconnectWallet}
																>
																	x
																</span>
															</>
														) : (
															"(Connect with Metamask)"
														)}
													</small>
												</p>
											</div>
										</div>

										<div className="right-side">
											<div>
												{connectedWallet != "undefined" &&
													connectedWallet?.length > 0 && (
														<div className="dfj left-text">
															<p className="mb-0">
																<small>Please Choose currency :</small>
															</p>
															<select
																className="currency-dropdown"
																value={selectedToken}
																onChange={handleSelectToken}
															>
																<option value={0} defaultChecked>
																	- select -
																</option>
																<option value={1}>WBTC.e</option>
																<option value={2}>WETH.e</option>
																<option value={3}>WAVAX</option>
																<option value={4}>DAI.e</option>
																<option value={5}>USDC.e</option>
																<option value={6}>USDT.e</option>
															</select>
														</div>
													)}
											</div>
											AMOUNT TO SHOW WHEN SELECTED 
											<div className="mt-3 ">
												{isWalletConnected == true
													? selectedToken != 0 && (
															<span className="d-block mb text-white">
																{paymentAmountToShow} {paymentTokenToshow}
															</span>
													  )
													: null}
											</div>
										</div>
									</div>
									<div className=" text-right flex-end-style approve-btn">
										{isWalletConnected == true && isAlreadyApproved == true && (
											<>
												<button
													className="pay-now-small less-padding-button mt-3"
													id="pay-now-btn"
													onClick={payWithWallet}
												>
													Pay with wallet
												</button>
											</>
										)}

										{isWalletConnected == true &&
											isAlreadyApproved == false &&
											connectedWallet != "undefined" &&
											walletAddress.length && (
												<>
													<button
														className="pay-now-small less-padding-button "
														id="pay-now-btn"
														onClick={approveNFTPaymentContract}
													>
														Approve
													</button>
												</>
											)}

										{(connectedWallet == "undefined" ||
											isWalletConnected == false ||
											walletAddress.length <= 0) && (
											<button
												className="pay-now-small less-padding-button "
												id="pay-now-btn"
												onClick={connectToWallet}
											>
												Connect Wallet
											</button>
										)}
									</div>
								</div> */}

								{/* PAY WITH NCash */}
								{/* <div className="ncash-pay-box">
                  <div className="ncash-pay">
                    <div className="text-left">
                      <h6 className="mb-1 ">Pay with NCash</h6>
                      <p
                        className="mb-1"
                      >
                        <small className="light-weight">
                          (Use Avalanche network)
                          
                        </small>
                        <small
                          style={{
                            // maxWidth: "50%",
                            wordBreak: "break-word",
                            // marginLeft: "10px",
                          }}
                        >
                          {walletAddress != "undefined" &&
                          walletAddress?.length ? (
                            <>
                              {"Connected : " +
                                walletAddress.slice(0, 5) +
                                ".".repeat(3) +
                                walletAddress.slice(-4)}
                              &nbsp;&nbsp;
                              <span
                                title="Disconnect Wallet"
                                style={{
                                  display: "inline-block",
                                  color: "white",
                                  cursor: "pointer",
                                  backgroundColor: "#161d30",
                                  width: "25px",
                                  height: "25px",
                                  fontSize: "15px",
                                  borderRadius: "50%",
                                  textAlign: "center",
                                }}
                                onClick={disconnectWallet}
                              >
                                x
                              </span>
                            </>
                          ) : (
                            "(Connect with Metamask)"
                          )}
                        </small>
                        
                        <small className="light mt-2 mb-0">
                          (Promo code not applicable)
                        </small>
                      </p>
                    </div>

                    <div className="right-side-ncash-details">
                      <div className="dfj" style={{ color: "white" }}>
                        <p className="mb-0">
                          <span>Total Ncash :</span>
                          <span>{totalNcash}</span>
                        </p>
                        <p className="mb-0">
                          <span>Discount : </span>
                          <span> - 15%</span>
                        </p>
                        <p className="mb-0">
                          <span> NCash : </span>
                          <span> {NCashBalance}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="text-right flex-end-style approve-btn">
                    {isWalletConnected == true && isAlreadyApproved == true && (
                      <>
                        <button
                          className="pay-now-small less-padding-button "
                          id="pay-now-btn"
                          onClick={payWithNcashWallet}
                        >
                          Pay with wallet
                        </button>
                      </>
                    )}
                    {isWalletConnected == true &&
                      isAlreadyApproved == false &&
                      connectedWallet != "undefined" &&
                      walletAddress.length && (
                        <>
                          <button
                            className="pay-now-small less-padding-button "
                            id="pay-now-btn"
                            onClick={approveNcashNFTPaymentContract}
                          >
                            Approve
                          </button>
                        </>
                      )}

                    {(connectedWallet == "undefined" ||
                      isWalletConnected == false ||
                      walletAddress.length <= 0) && (
                      <button
                        className="pay-now-small less-padding-button "
                        id="pay-now-btn"
                        onClick={connectToWallet}
                      >
                        Connect Wallet
                      </button>
                    )}
                  </div>
                </div> */}
							</div>
						</div>
						{/* <marquee
              vspace="100"
              style={{ fontWeight: "bold", color: "#333333", fontSize: 18 }}
            >
              Pay with NCash to avail 15% discount
              <span
                style={{
                  display: "inline-block",
                  width: "10vw",
                  color: "#333333",
                }}
              ></span>
              Pay with NCash to avail 15% discount
              <span
                style={{
                  display: "inline-block",
                  width: "10vw",
                  color: "#333333",
                }}
              ></span>
              Pay with NCash to avail 15% discount
              <span
                style={{
                  display: "inline-block",
                  width: "10vw",
                  color: "#333333",
                }}
              ></span>
            </marquee> */}
					</div>
				</div>
			</div>
			<div className="max-width-55">
				<div className="exchnage-section container">
					<h3>Get your NCash here</h3>
					<div className="max-width-55">
						<div className="exhanges-box">
							<a
								href="https://www.huobi.com/en-us/exchange/ncash_btc/"
								className="huobi-box"
								target="_blank"
							>
								<img src={huobi} alt="Hobo" />
								<p>Click here to get NCash</p>
							</a>
							<a
								href="https://app.pangolin.exchange/#/swap"
								className="huobi-box"
								target="_blank"
							>
								<img src={pangolin} alt="Hobo" />
								<p>Click here to get NCash</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default BuyNFM;
